export type MembershipsMap<
  TMemberships extends {
    idMember: string;
    memberType: 'admin' | 'normal' | 'observer';
  }[],
> = Map<string, TMemberships[number]>;

/**
 * Builds a Map of idMember to membership
 * @param memberships Array of memberships from board or organization
 * @returns Map
 */
export const getMembershipsMap = <
  TMemberships extends {
    idMember: string;
    memberType: 'admin' | 'normal' | 'observer';
  }[],
>(
  memberships: TMemberships,
): MembershipsMap<TMemberships> => {
  const membershipsMap = new Map();

  memberships.forEach((membership) =>
    membershipsMap.set(membership.idMember, membership),
  );

  return membershipsMap;
};
